<template>
  <v-card class="pa-4 " elevation="6" style="width:70%">
          <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                         Extract Entities From Text
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-textarea 
          outlined
          label= "Insert Text to Process"
          v-model="text"
        ></v-textarea>
         <v-col class="text-right ma-0 pa-0">
        <v-btn   type='submit' @click="postUnstructuredText"> Process Text </v-btn>
         </v-col>
         <div v-if="items.length != 0">
         <h4 class="font-weight-light text-h5">
                        Result:
                        </h4>

    <div  class="entities  pa-4 mt-3" style=" line-height: 2.5; direction: ltr; background: #F4F4F4; border-radius: 10px;">
        <span v-for="(token,j) in processLine" 
        :key="j" ref="target">
            <template v-if="token[1]=='O'">
            <label style=" line-height: 3.4;white-space: normal;" >
            <span class="text-md-body-1"   style="color: black; white-space: pre-line"  data-flag="biotoken">{{token[0]}} </span>
        
            </label>
            </template>
        <template v-else-if="token[1]=='B'">
            <label style=" line-height: 3.4;white-space: normal;" :data-tokenIndex="j" data-flag="biotoken">
            <span  class="text-md-body-1 font-weight-bold"  style="text-decoration: none; white-space: pre-line">
            <mark class="entity" :style={background:getLabelColor(0,j)}>
                {{token[0]}}
                <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">{{token[2]}}</span>
            </mark>
            </span>
            </label>
        </template>
        </span>
    </div>
         </div>
    <div class="loading" v-if="loading">
    <div class="loader"></div>
    </div>
</v-card>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

const dataAPI = require("@/config/hosts").dataAPI;
export default {
    name:"Entities",
 data() {
    return {
        loading:false,
        text: "",
        label1Color:"#ddd", //#E4E7D2 #ddd
        label2Color:"#7AECEC",
        label3Color:"#AA9CFC",
        label4Color:"#FECA74",
        label5Color:"#BFE1D9",
        label1:"Organizacao",
        label2:"Pessoa",
        label3:"Local",
        label4:"Profissao",
        label5:"Data",
        items :[]
    }
  },
    methods:{
    getLabelColor:function(i,j){
      if(this.items[i][j][2] == this.label1)
        return this.label1Color
      if(this.items[i][j][2] == this.label2)
        return this.label2Color
      if(this.items[i][j][2] == this.label3)
        return this.label3Color
      if(this.items[i][j][2] == this.label4)
        return this.label4Color
      if(this.items[i][j][2] == this.label5)
        return this.label5Color
    },
    postUnstructuredText: function(){
        if  (this.text == "") { alert("Please insert some text"); return false;}
          this.loading=true
 
        axios.post(dataAPI+'annotator/unstructuredText/text', {"texto":this.text},{"timeout": 3000000})
          .then((dados) => { 
          console.log(dados.data)
          this.items = dados.data
          this.createSetences()
          this.loading=false
          
         })
        .catch((error)=>{this.loading=false})
      },
    },
  computed:{
    processLine: function(){
          if(this.items.length == 0) return
          var i = 0
          var newLine = JSON.parse(JSON.stringify(this.items[i]))
          console.log(this.items[0])
            var j = 0;
            var k = 0;
              for(j = 0; j < this.items[i].length; j++){
                  if(this.items[i][j][1] == 'B'){
                      k = j + 1
                      while(this.items[i][k] != undefined && this.items[i][k][1] == 'I'){
                        newLine[j][0] += " " +this.items[i][k][0]
                        k++
                      }  
                  }
              }
            console.log(newLine)
          return newLine;         
      },
  }
}
</script>
<style>
.entity{
 padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;
}

.v-text-field.v-text-field--solo .v-input__control { min-height: 10px; }
.v-text-field--box .v-input__slot, .v-text-field--outline .v-input__slot { min-height: 10px; }
</style>